<template>
    <div class="container">
        <div class="login-panel">
            <div class="login-panel-title">
                <img alt="技术一点通" class="logo" src="@/assets/logo.full.png"/>
            </div>
            <div class="login-panel-form">
                <el-form ref="loginForm" :model="form" :rules="rules" label-width="80px">
                    <el-form-item label="电话" prop="phone">
                        <el-input v-model="form.phone" placeholder="请输入您注册用的手机号码"/>
                    </el-form-item>
                    <el-form-item label="密码" prop="password">
                        <el-input v-model="form.password" show-password placeholder="请输入密码"/>
                    </el-form-item>
                    <el-form-item>
                        <el-button
                            type="primary"
                            size="large"
                            @click="login"
                            :loading="isLoading"
                            style="width:100%"
                        >登录</el-button>
                    </el-form-item>
                    <el-form-item>
                        <div class="center">
                            <el-button
                                type="text"
                                size="mini"
                                icon="el-icon-question"
                                style="color:#606266"
                                @click="openResetPassDialog"
                            >忘记密码</el-button>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <el-dialog title="找回密码" :visible.sync="resetPassDialogFormVisible" width="400px">
            <el-form :model="recovery" :rules="rules" ref="resetPassForm">
                <el-form-item label="注册邮箱" prop="email">
                    <el-input v-model="recovery.email" autocomplete="off"/>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="resetPassDialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="resetPass">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import oxValidator from '@/ox/core/Validator';

export default {
    data() {
        let validatePhone = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入注册时用的手机号"));
            } else if (!oxValidator.isMobileNumber(value)) {
                callback(new Error("您输入的手机号无效"));
            } else {
                callback();
            }
        };
        return {
            isLoading: false,
            isProcessing: false,
            resetPassDialogFormVisible: false,
            recovery: {
                email: ""
            },
            form: {
                phone: "",
                password: ""
            },
            rules: {
                phone: [
                    { validator: validatePhone, trigger: "blur" }
                ],
                password: [
                    {
                        required: true,
                        message: "密码不能为空",
                        trigger: "blur"
                    },
                    {
                        min: 6,
                        max: 32,
                        message: "长度在 8 到 24 个字符",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    methods: {
        login() {
            this.$refs["loginForm"].validate(valid => {
                if (valid) {
                    this.doLogin();
                } else {
                    this.$message({
                        message: "你的填写的信息有误，请修改后再提交",
                        type: "warning"
                    });
                    return false;
                }
            });
        },
        doLogin() {
            this.$ox.session.clear();
            this.isLoading = true;
            window.BaaS.auth
                .login({
                    phone: this.form.phone,
                    password: this.form.password
                })
                .then(data => {
                    this.isLoading = false;
                    let user = data.toJSON();
                    this.setCurrentUser(user);
                    if(user.is_admin===1){
                        this.$router.push('/').catch(()=>{
                        });
                    }else{
                        this.$router.push('/401');
                    }

                })
                .catch(err => {
                    this.$message({
                        message: err,
                        type: "error"
                    });
                    this.isLoading = false;
                });
        },
        openResetPassDialog() {
            this.recovery.email = "";
            this.resetPassDialogFormVisible = true;
        },
        resetPass() {
            this.$refs["resetPassForm"].validate(valid => {
                if (valid) {
                    window.BaaS.auth
                        .requestPasswordReset({ email: this.recovery.email })
                        .then(() => {
                            this.resetPassDialogFormVisible = false;
                            this.$alert(
                                "已发送密码重置邮件，请在 10 分钟内查收并修改密码",
                                "操作成功",
                                {
                                    confirmButtonText: "确定"
                                }
                            );
                        })
                        .catch(() => {
                            this.$message.error("该邮箱尚未验证或注册");
                        });
                } else {
                    this.$message.warning("邮箱填写有误");
                    return false;
                }
            });
        }
    }
};
</script>

<style scoped>
.container {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    background: #f0f2f5 url(../../assets/background.png) no-repeat top center;
    background-size: 100% 100%;
    text-align: center;
}
.login-panel {
    width: 600px;
    margin: 100px auto 0 auto;
    padding-top: 40px;
    position: relative;
}
.login-panel-title{
    display: flex;
    justify-content: center;
    align-items: center;
    color:#ADBECF;
    margin-bottom: 20px;
    overflow-x:hidden;
}
.login-panel-title .logo {
    width: 260px;
    vertical-align: middle;
}
.login-panel-title > span{
    font-size: 32px;
    font-weight: bold;
    border-left: 1px solid #bbcad9;
    display: inline-block;
    margin-left:15px;
    padding-left: 15px;
    line-height: 80px;
    white-space : nowrap;
}
.login-panel-form{
    width: 400px;
    padding: 20px 60px 40px 20px;
    margin:0 auto;
}
.register-link {
    color: #409eff;
    text-decoration: none;
    font-size: 12px;
}
</style>

